<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">{{ $t("MyEarnings") }}</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i
          ></a>
        </div>
      </div>
    </div>

    <div class="topFilter">
      <div class="container lg">
        <div class="form-group">
          <label for="filter" class="sr-only">Filter</label>
          <input
            type="text"
            class="form-control filter"
            v-model="filter"
            placeholder="Search..."
          />
        </div>
      </div>
    </div>

    <div class="loader-example" v-if="!ready">
      <div class="loader-bar"></div>
    </div>
    <div class="container-center lg animated fadeIn" v-else>
      <div v-if="history_rows.length != 0">
        <datatable
          :columns="history_columns"
          :data="history_rows"
          :filter-by="filter"
          class=""
        >
          <template slot-scope="{ row }">
            <tr
              class="pointer"
              v-on:click="
                expand(row._id);
                setCountdown(row.period, row.createdAt);
              "
            >
              <td>
                {{ row.currencyIN }}
                <i class="fad fa-arrow-circle-right"></i>
                {{ row.currencyOUT }}
              </td>
              <td class="text-right">
                {{ row.type }}
              </td>
              <td class="text-center">
                <span v-bind:class="' label ' + row.label">{{
                  row.status
                }}</span>
              </td>
            </tr>
            <tr v-if="expanded == row._id">
              <td colspan="3">
                <div class="panel panel-filled">
                  <div class="panel-body text-center">
                    <div class="col-xs-12">
                      <div class="coin text-center">
                        {{ countdown }}
                      </div>
                    </div>
                    <div class="col-xs-6">
                      <small class="stat-label">{{ row.type }}</small>
                      <h5 class="m-t-xs">
                        {{ row.currencyIN }}
                        <i class="fad fa-arrow-circle-right"></i>
                        {{ row.currencyOUT }}
                      </h5>
                    </div>
                    <div class="col-xs-6">
                      <small class="stat-label">{{ $t("CapitalSwap") }}</small>
                      <h5 class="m-t-xs">
                        {{ fixed(row.amount) }}
                        {{ row.currencyIN }}
                      </h5>
                    </div>
                    <div class="col-xs-6">
                      <small class="stat-label">{{ $t("Remaining") }}</small>
                      <h5 class="m-t-xs">
                        {{ getRemaining(row.period, row.day) }}
                      </h5>
                    </div>
                    <div class="col-xs-6">
                      <small class="stat-label">{{ $t("Fee") }}</small>
                      <h5 class="m-t-xs">
                        {{ fixed(row.fee_daily * row.period) }}
                        {{ row.currencyOUT }}
                      </h5>
                    </div>
                    <div class="col-xs-6">
                      <small class="stat-label">Total Net. Profit</small>
                      <h5 class="m-t-xs c-accent">
                        {{ fixed(row.profit_daily * row.period) }}
                        {{ row.currencyOUT }}
                      </h5>
                    </div>
                    <div class="col-xs-6">
                      <small class="stat-label">{{ $t("DailyProfit") }}</small>
                      <h5 class="m-t-xs c-accent">
                        {{ fixed(row.profit_daily) }}
                        {{ row.currencyOUT }}
                      </h5>
                    </div>
                    <div class="col-xs-12">
                      <router-link v-bind:to="'/txrelation/' + row.hash"
                        ><button class="btn btn-accent">
                          Transactions
                        </button>
                      </router-link>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </datatable>
        <div class="pager-footer">
          <datatable-pager
            v-model="page"
            type="abbreviated"
            :per-page="per_page"
            class="text-center"
          ></datatable-pager>
        </div>
      </div>
      <div v-else>
        <div class="container-center lg loader-example text-center">
          <i class="fad fa-search fa-4x"></i>
          <h4>You have no swapping.</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import label from "@/widgets/label";
import investbox from "@/api/investbox";
import func from "@/widgets/func";
import nativeToast from "native-toast";
import moment from "moment";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      period: null,
      createdAt: null,
      countdown: null,
      ready: false,
      filter: "",
      history_columns: [
        {
          label: "Investment",
          field: "currencyIN",
          align: "left",
          sortable: true
        },
        {
          label: "Type",
          field: "type",
          align: "right",
          sortable: false
        },
        {
          label: "Status",
          field: "status",
          align: "center",
          sortable: false
        }
      ],
      history_rows: [],
      page: 1,
      per_page: 19,
      expanded: null
    };
  },
  methods: {
    ...mapActions(["fetchInvest"]),
    fixed(a) {
      return func.fixed(a);
    },
    expand(id) {
      if (this.expanded == id) {
        this.expanded = null;
        return;
      }
      this.expanded = id;
    },
    getRemaining(period, day) {
      if (period - day > 0) {
        return `${period - day} payment`;
      } else {
        return "COMPLETE";
      }
    },
    setCountdown(period, createdAt) {
      this.period = period;
      this.createdAt = createdAt;
    },
    getCountdown() {
      if (this.period && this.createdAt) {
        const now = new Date();
        const begin = new Date(this.createdAt);
        const end = begin.getTime() + this.period * 1000 * 60 * 60 * 24;

        var duration = end - now.getTime();

        if (duration > 0) {
          var seconds = parseInt((duration / 1000) % 60);
          var minutes = parseInt((duration / 60000) % 60);
          var hours = parseInt((duration / 3600000) % 24);
          var days = parseInt((duration / 86400000) % 86400);

          hours = hours < 10 ? "0" + hours : hours;
          minutes = minutes < 10 ? "0" + minutes : minutes;
          seconds = seconds < 10 ? "0" + seconds : seconds;
          if (days > 1)
            this.countdown = `${days} Days ${hours}:${minutes}:${seconds}`;
          else if (days > 0)
            this.countdown = `${days} Day ${hours}:${minutes}:${seconds}`;
          else this.countdown = `${hours}:${minutes}:${seconds}`;
        } else {
          this.countdown = `COMPLETE`;
        }
      }
    },
    getdata() {
      investbox
        .contract()
        .then(res => {
          this.history_rows = [];
          this.ready = true;
          res.data.forEach(e => {
            e.createdAt = moment(e.createdAt).format("Y-MM-DD H:mm:s");

            var a = label.type(e.status);
            e.label = a.label;

            this.history_rows.push(e);
          });
        })
        .catch(error => {
          nativeToast({
            message: error.response.data.error,
            position: "top",
            timeout: 3000,
            type: "error"
          });
        });
    }
  },
  mounted() {
    window.setInterval(() => {
      this.getCountdown();
    }, 500);

    this.fetchInvest();
    this.getdata();
  }
};
</script>

<style scoped>
h5 {
  font-weight: bold;
}
.container-center {
  margin-top: 80px;
  padding: 0 0 150px 0;
}
.loader-example {
  margin-top: 200px;
}
td {
  white-space: nowrap;
}
.coin img {
  margin-left: 20px;
}
.coin {
  color: white;
  font-size: 20px;
}
</style>
